var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"header"}},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/sms_white.svg"),"alt":"Somos Educação"}})])
}]

export { render, staticRenderFns }